import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ObjectivesChart from '../../ClientDetail/ObjectiveChart';
import { IClientProgressData } from '../../../redux/client/clientSlice';
import { useAppSelector } from '../../../redux/hooks';
import { RoundedSkeleton } from '../../ClientTable/LoadingSkeleton';

interface ProgressAsReportedProps {
  objectiveProgress: IClientProgressData[];
}

function ProgressAsReported({ objectiveProgress }: ProgressAsReportedProps) {
  const { t } = useTranslation();
  const clientActivityProgressLoading = useAppSelector(
    (state) => state.client.clientActivityProgressLoading
  );

  return (
    <>
      {clientActivityProgressLoading ? (
        <Grid gap={1} display="flex" flexDirection="column">
          <RoundedSkeleton variant="rounded" width={231} height={17.5} />
          <RoundedSkeleton variant="rounded" width={90} height={17.5} />
        </Grid>
      ) : (
        <Typography variant="h6" color="primary">
          {t('clientProgress.progressAsReported')}
        </Typography>
      )}
      <Grid>
        <ObjectivesChart objectiveProgress={objectiveProgress} />
      </Grid>
    </>
  );
}

export default ProgressAsReported;
